import { lazy } from 'react'

import { paths } from './paths'

const PagePlaybook = lazy(() => import('pages/playbook/PagePlaybook'))
const PagePlaylist = lazy(() => import('pages/playlist/PagePlaylist'))
const PageScorm = lazy(() => import('pages/PageScorm'))
const PageSsoLogin = lazy(() => import('pages/PageSsoLogin'))
const PageCollection = lazy(() => import('pages/collection/PageCollection'))

export const routes = [
    // Alternative routes with underscore patterns (more specific - must come first)
    { path: paths.playlistDetailsEUUnderscore, component: <PagePlaylist /> },
    { path: paths.playbookDetailsEUUnderscore, component: <PagePlaybook /> },
    { path: paths.playlistDetailsPlaybooksUnderscore, component: <PagePlaylist /> },
    { path: paths.collectionDetailsEUUnderscore, component: <PageCollection /> },

    // General routes (less specific - must come after)
    { path: paths.playbookDetails, component: <PagePlaybook /> },
    { path: paths.playlistDetails, component: <PagePlaylist /> },
    { path: paths.ssoLogin, component: <PageSsoLogin /> },
    { path: paths.ssoTenantLogin, component: <PageSsoLogin /> },
    { path: paths.scorm, component: <PageScorm /> },
    { path: paths.collectionDetails, component: <PageCollection /> },
]

export type RoutesType = typeof routes
